// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as OrderPricingTableVm from "./vm-mappers/OrderPricingTableVm.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function getTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Min Distance"
            },
            accessor: (function (p) {
                return {
                        TAG: /* Text */0,
                        _0: p.lower_km
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Max Distance"
              },
              accessor: (function (p) {
                  return {
                          TAG: /* Text */0,
                          _0: p.upper_km
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Price per min"
                },
                accessor: (function (p) {
                    return {
                            TAG: /* Text */0,
                            _0: p.price_per_min
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Price per km"
                  },
                  accessor: (function (p) {
                      return {
                              TAG: /* Text */0,
                              _0: p.price_per_km
                            };
                    })
                },
                tl: /* [] */0
              }
            }
          }
        };
}

function OrderPricingTable(Props) {
  var order_fare = Props.order_fare;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  var match$1 = order_fare.customer;
  if (match$1 === undefined) {
    return null;
  }
  var order_pricings = OrderPricingTableVm.getVm(match$1.pricing, currency);
  return React.createElement("div", {
              className: "order-pricing-table"
            }, React.createElement("div", {
                  className: "title"
                }, "Order Pricings"), React.createElement(TableComponent$Catalyst.make, {
                  columns: getTableColumnsSchema(undefined),
                  rowData: order_pricings,
                  className: "c-nlo-table"
                }));
}

var make = OrderPricingTable;

export {
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
